import React, { ReactNode } from 'react';
import { AlertCircleIcon } from 'lucide-react';
type FieldProps = {
  id: string;
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  children: ReactNode;
};
export function Field({
  id,
  label,
  required = false,
  hint,
  error,
  className = '',
  children
}: FieldProps) {
  return <div className={className} data-id="element-44" data-mp="3vac1ay7heoch">
      <label htmlFor={id} className="block text-sm font-medium text-ink" data-id="element-45" data-mp="42ppgialzfkj">
        {label}
        {required ? <span className="text-gold-deep" aria-hidden="true" data-id="element-46" data-mp="919dqpcod3g2">
            {' '}
            *
          </span> : <span className="font-normal text-muted" data-id="element-47" data-mp="dtkgs12pp5cu"> (optional)</span>}
      </label>
      {hint && <p id={`${id}-hint`} className="mt-1 text-[13px] text-muted" data-id="element-48" data-mp="iqaw2m6ozwx7">
          {hint}
        </p>}
      <div className="mt-2" data-id="element-49" data-mp="musccbdufs38">{children}</div>
      {error && <p id={`${id}-error`} className="mt-2 flex items-start gap-1.5 text-[13px] text-danger" data-id="element-50" data-mp="rriquua02fmj">
          <AlertCircleIcon className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-51" data-mp="1la64ipa8kfnu" />
          {error}
        </p>}
    </div>;
}